import { cn } from '@/lib/utils';
import { format } from 'date-fns';
import { Check, CheckCheck } from 'lucide-react';

interface MessageBubbleProps {
  content: string;
  isOwnMessage: boolean;
  timestamp: string;
  status?: 'sent' | 'delivered' | 'read' | 'failed';
  isAiSuggested?: boolean;
}

export function MessageBubble({
  content,
  isOwnMessage,
  timestamp,
  status,
}: MessageBubbleProps) {
  const time = format(new Date(timestamp), 'h:mm a');

  return (
    <div
      className={cn(
        'flex flex-col max-w-[75%]',
        isOwnMessage ? 'items-end ml-auto' : 'items-start mr-auto'
      )}
    >
      <div
        className={cn(
          'rounded-2xl px-4 py-2 shadow-sm',
          isOwnMessage
            ? 'bg-brand-primary text-white rounded-br-md'
            : 'bg-brand-surface border border-brand-border text-white rounded-bl-md'
        )}
      >
        <p className="text-sm whitespace-pre-wrap break-words">{content}</p>
      </div>

      <div
        className={cn(
          'flex items-center gap-1 mt-1 text-xs text-brand-muted',
          isOwnMessage ? 'flex-row-reverse' : 'flex-row'
        )}
      >
        <span>{time}</span>

        {isOwnMessage && status && (
          <span className="ml-1">
            {status === 'sent' && <Check className="w-3 h-3" />}
            {status === 'delivered' && <CheckCheck className="w-3 h-3" />}
            {status === 'read' && <CheckCheck className="w-3 h-3 text-blue-500" />}
            {status === 'failed' && (
              <span className="text-red-500 text-xs">!</span>
            )}
          </span>
        )}
      </div>
    </div>
  );
}
